import { render, staticRenderFns } from "./PaytableImage.vue?vue&type=template&id=0cc6d8d0&"
import script from "./PaytableImage.vue?vue&type=script&lang=ts&"
export * from "./PaytableImage.vue?vue&type=script&lang=ts&"
import style0 from "./PaytableImage.vue?vue&type=style&index=0&id=0cc6d8d0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports